import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class FullPageMaskService {

  public isVisible = new BehaviorSubject<boolean>(true);

  constructor() {}

  showLoading() {
    this.isVisible.next(true);
  }

  hideLoading() {
    this.isVisible.next(false);
  }

}
